import React, { useState, useEffect } from 'react';
import {
  useColorModeValue } from "./ui/color-mode";
import { Alert,
  Box,
  Checkbox,
  Button,
  HStack,
  VStack,
  Collapsible,
  Text,
} from '@chakra-ui/react';

const ProfilePreviewDisclaimer = ({ profileType = 'banda' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  
  const storageKey = `hideProfilePreviewDisclaimer_${profileType}`;
  
  const bgColor = useColorModeValue('blue.50', 'blue.900');
  const borderColor = useColorModeValue('blue.200', 'blue.700');
  
  // Verificar si el disclaimer debe mostrarse al montar el componente
  useEffect(() => {
    const shouldHide = localStorage.getItem(storageKey) === 'true';
    if (!shouldHide) {
      setIsVisible(true);
    }
  }, [storageKey]);

  const handleAccept = () => {
    if (dontShowAgain) {
      localStorage.setItem(storageKey, 'true');
    }
    setIsVisible(false);
  };

  const getDisclaimerText = () => {
    if (profileType === 'cofradia') {
      return {
        title: 'Vista Previa del Perfil Público',
        description: 'Esta es la vista previa de cómo verán las bandas tu perfil público. Aquí podrás revisar toda la información que será visible para las agrupaciones musicales que consulten tu perfil.'
      };
    }
    return {
      title: 'Vista Previa del Perfil Público',
      description: 'Esta es la vista previa de cómo verán las cofradías tu perfil público. Aquí podrás revisar toda la información que será visible para las entidades que visiten tu perfil.'
    };
  };

  const disclaimerContent = getDisclaimerText();

  if (!isVisible) return null;

  return (
    <Collapsible.Root open={isVisible}>
      <Collapsible.Content>
        <Box mb={6}>
          <Alert.Root
            status="info"
            variant="subtle"
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="center"
            textAlign="left"
            bg={bgColor}
            border="1px solid"
            borderColor={borderColor}
            borderRadius="2xl"
            p={6}
          >
            <HStack align="flex-start" gap={3} w="full">
              <Alert.Indicator />
              <VStack align="stretch" gap={3} flex={1}>
                <Box>
                  <Alert.Title fontSize="lg" mb={2}>
                    {disclaimerContent.title}
                  </Alert.Title>
                  <Alert.Description fontSize="sm" lineHeight="tall">
                    {disclaimerContent.description}
                  </Alert.Description>
                </Box>
                
                <VStack align="stretch" gap={3}>
                  <Checkbox.Root
                    size="sm"
                    onCheckedChange={(details) => setDontShowAgain(details.checked === true)}
                    colorPalette="blue"
                    checked={dontShowAgain}
                  ><Checkbox.HiddenInput /><Checkbox.Control><Checkbox.Indicator /></Checkbox.Control><Checkbox.Label>
                    <Text fontSize="sm">No volver a mostrar este aviso</Text>
                  </Checkbox.Label></Checkbox.Root>
                  
                  <HStack justify="flex-end">
                    <Button
                      size="md"
                      bg="blue.600"
                      color="white"
                      onClick={handleAccept}
                      rounded="full"
                      fontWeight="600"
                      _hover={{ bg: 'blue.700', transform: 'scale(1.02)' }}
                      _active={{ transform: 'scale(0.98)' }}
                    >
                      Entendido
                    </Button>
                  </HStack>
                </VStack>
              </VStack>
            </HStack>
          </Alert.Root>
        </Box>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};

export default ProfilePreviewDisclaimer;
